import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-loading-placeholder',
  imports: [],
  template: `<div
    class="MainLoader"
    aria-busy="true">
    <div
      class="MainLoader-wrapper"
      aria-hidden="false"
      aria-label="Loading">
      <img
        src="assets/logo/v3/logo-full-white.svg"
        width="100"
        height="48"
        priority />
      <img
        class="Spinner-icon Spinner-iconWhite"
        src="/assets/icon/spinner.svg" />
    </div>
    <img
      src="assets/logo/v3/logo-small.svg"
      width="99px"
      height="24px"
      priority />
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingPlaceholderComponent {}
